// ForgotPasswordModal.tsx
import React, { useState } from 'react';
import './ForgotPasswordModal.css';
import axios from './axiosConfig';

interface Props {
    isOpen: boolean;
    onClose: () => void;
}

const ForgotPasswordModal: React.FC<Props> = ({ isOpen, onClose }) => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    if (!isOpen) return null;

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            const response = await axios.post('/api/recover-password', { email });
            if (response.status === 200) {
                setMessage('Please check your email to reset your password.');
            } else {
                // 这个分支实际上可能不会被执行，因为 axios 在非 2xx 响应时抛出异常
                setMessage('Email not found.');
            }
        } catch (error) {
            // @ts-ignore
            if (error.response && error.response.status === 404) {
                // 当服务器返回404状态码时特别处理
                setMessage('Email not found.');
            } else {
                // 其他所有错误
                setMessage('Failed to send reset email. Please try again later.');
            }
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Forgot Password</h2>
                <form onSubmit={handleSubmit}>
                    <input
                        type="email"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    <button type="submit" disabled={loading}>
                        {loading ? 'Sending...' : 'Send Reset Link'}
                    </button>
                </form>

                {message && <p className="success-message">{message}</p>}
                {error && <p className="error-message">{error}</p>}

                <button onClick={onClose} className="close-button">Close</button>
            </div>
        </div>
    );
};

export default ForgotPasswordModal;
